var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAntlogyWsGridIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 800,
    zoomAndPan: "magnify",
    viewBox: "0 0 600 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a77a309b91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.734375 202.394531 L 570.710938 202.394531 L 570.710938 353.265625 L 115.734375 353.265625 Z M 115.734375 202.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0d968204f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.234375 202.394531 L 547.652344 202.394531 C 553.617188 202.394531 559.339844 204.765625 563.5625 208.984375 C 567.78125 213.203125 570.152344 218.925781 570.152344 224.894531 L 570.152344 330.765625 C 570.152344 336.734375 567.78125 342.457031 563.5625 346.675781 C 559.339844 350.894531 553.617188 353.265625 547.652344 353.265625 L 138.234375 353.265625 C 132.269531 353.265625 126.546875 350.894531 122.328125 346.675781 C 118.105469 342.457031 115.734375 336.734375 115.734375 330.765625 L 115.734375 224.894531 C 115.734375 218.925781 118.105469 213.203125 122.328125 208.984375 C 126.546875 204.765625 132.269531 202.394531 138.234375 202.394531 Z M 138.234375 202.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7bc2bb2774"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.734375 0.394531 L 455.238281 0.394531 L 455.238281 151.265625 L 0.734375 151.265625 Z M 0.734375 0.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8b57d2338b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.234375 0.394531 L 432.652344 0.394531 C 438.617188 0.394531 444.339844 2.765625 448.5625 6.984375 C 452.78125 11.203125 455.152344 16.925781 455.152344 22.894531 L 455.152344 128.765625 C 455.152344 134.734375 452.78125 140.457031 448.5625 144.675781 C 444.339844 148.894531 438.617188 151.265625 432.652344 151.265625 L 23.234375 151.265625 C 17.269531 151.265625 11.546875 148.894531 7.328125 144.675781 C 3.105469 140.457031 0.734375 134.734375 0.734375 128.765625 L 0.734375 22.894531 C 0.734375 16.925781 3.105469 11.203125 7.328125 6.984375 C 11.546875 2.765625 17.269531 0.394531 23.234375 0.394531 Z M 23.234375 0.394531 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cf64950b98"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 456,
    y: 0,
    height: 152
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eaaa4b04f4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 29.777344 21.734375 L 86.042969 21.734375 L 86.042969 353.40625 L 29.777344 353.40625 Z M 29.777344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "418bae6fca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 52.277344 21.734375 L 63.542969 21.734375 C 69.511719 21.734375 75.234375 24.105469 79.453125 28.324219 C 83.675781 32.542969 86.042969 38.265625 86.042969 44.234375 L 86.042969 330.765625 C 86.042969 336.734375 83.675781 342.457031 79.453125 346.675781 C 75.234375 350.894531 69.511719 353.265625 63.542969 353.265625 L 52.277344 353.265625 C 46.308594 353.265625 40.585938 350.894531 36.367188 346.675781 C 32.148438 342.457031 29.777344 336.734375 29.777344 330.765625 L 29.777344 44.234375 C 29.777344 38.265625 32.148438 32.542969 36.367188 28.324219 C 40.585938 24.105469 46.308594 21.734375 52.277344 21.734375 Z M 52.277344 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "42fc258739"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.777344 0.734375 L 57.042969 0.734375 L 57.042969 332.28125 L 0.777344 332.28125 Z M 0.777344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "478862679c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.277344 0.734375 L 34.542969 0.734375 C 40.511719 0.734375 46.234375 3.105469 50.453125 7.324219 C 54.675781 11.542969 57.042969 17.265625 57.042969 23.234375 L 57.042969 309.765625 C 57.042969 315.734375 54.675781 321.457031 50.453125 325.675781 C 46.234375 329.894531 40.511719 332.265625 34.542969 332.265625 L 23.277344 332.265625 C 17.308594 332.265625 11.585938 329.894531 7.367188 325.675781 C 3.148438 321.457031 0.777344 315.734375 0.777344 309.765625 L 0.777344 23.234375 C 0.777344 17.265625 3.148438 11.542969 7.367188 7.324219 C 11.585938 3.105469 17.308594 0.734375 23.277344 0.734375 Z M 23.277344 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d46bcaf767"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 58,
    y: 0,
    height: 333
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f08ce27f62"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 116.117188 21.734375 L 571 21.734375 L 571 172.605469 L 116.117188 172.605469 Z M 116.117188 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8e6ec45b43"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 138.617188 21.734375 L 548.03125 21.734375 C 554 21.734375 559.722656 24.105469 563.941406 28.324219 C 568.160156 32.542969 570.53125 38.265625 570.53125 44.234375 L 570.53125 150.105469 C 570.53125 156.074219 568.160156 161.796875 563.941406 166.015625 C 559.722656 170.234375 554 172.605469 548.03125 172.605469 L 138.617188 172.605469 C 132.648438 172.605469 126.925781 170.234375 122.707031 166.015625 C 118.488281 161.796875 116.117188 156.074219 116.117188 150.105469 L 116.117188 44.234375 C 116.117188 38.265625 118.488281 32.542969 122.707031 28.324219 C 126.925781 24.105469 132.648438 21.734375 138.617188 21.734375 Z M 138.617188 21.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5f3e20f3a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.117188 0.734375 L 454.71875 0.734375 L 454.71875 151.605469 L 0.117188 151.605469 Z M 0.117188 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c177784247"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.617188 0.734375 L 432.03125 0.734375 C 438 0.734375 443.722656 3.105469 447.941406 7.324219 C 452.160156 11.542969 454.53125 17.265625 454.53125 23.234375 L 454.53125 129.105469 C 454.53125 135.074219 452.160156 140.796875 447.941406 145.015625 C 443.722656 149.234375 438 151.605469 432.03125 151.605469 L 22.617188 151.605469 C 16.648438 151.605469 10.925781 149.234375 6.707031 145.015625 C 2.488281 140.796875 0.117188 135.074219 0.117188 129.105469 L 0.117188 23.234375 C 0.117188 17.265625 2.488281 11.542969 6.707031 7.324219 C 10.925781 3.105469 16.648438 0.734375 22.617188 0.734375 Z M 22.617188 0.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7e8bc82aed"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 455,
    y: 0,
    height: 152
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a77a309b91)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0d968204f9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 115, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cf64950b98)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7bc2bb2774)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8b57d2338b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.734375 0.394531 L 455.125 0.394531 L 455.125 151.265625 L 0.734375 151.265625 Z M 0.734375 0.394531 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eaaa4b04f4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#418bae6fca)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 29, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d46bcaf767)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#42fc258739)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#478862679c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.777344 0.734375 L 57.042969 0.734375 L 57.042969 332.1875 L 0.777344 332.1875 Z M 0.777344 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f08ce27f62)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8e6ec45b43)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 116, 21)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7e8bc82aed)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5f3e20f3a2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c177784247)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.117188 0.734375 L 454.503906 0.734375 L 454.503906 151.605469 L 0.117188 151.605469 Z M 0.117188 0.734375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntlogyWsGridIcon2);
export default __webpack_public_path__ + "static/media/antlogyWSGridIcon2.7715273152f5ea98a1483b6e328335b6.svg";
export { ForwardRef as ReactComponent };